export default __webpack_public_path__ + "static/media/Chan06.01ae749d.png";